import {createSettingsParams, SettingsParamType} from '@wix/tpa-settings'

export type TextsSettingsParams = {
  titleText: SettingsParamType.Text
  titleRequestText: SettingsParamType.Text
  buttonLabelText: SettingsParamType.Text
  buttonLabelRequestText: SettingsParamType.Text
}

export const textsSettingsParams = createSettingsParams<TextsSettingsParams>({
  titleText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('uou-reservations.reservation-details.title'),
  },
  titleRequestText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('uou-reservations.reservation-details.title.request'),
  },
  buttonLabelText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('uou-reservations.reservation-details.complete.cta'),
  },
  buttonLabelRequestText: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('uou-reservations.reservation-details.complete.cta.request'),
  },
})
